import { useTranslation } from 'react-i18next'

import { ChatDotsIcon } from '@phosphor-icons/react'

import {
  Alert,
  Button,
  ButtonWithSpinner,
  CardTitle,
  Drawer,
  GiftCardIcon,
  InputWithLabel,
  Switch,
  Text,
} from '@reveni-io/reveni-ui'

import GiftCardBalance from './GiftCardBalance/GiftCardBalance'
import * as Styles from './styles'

const CancelGiftCardDrawer = ({
  show,
  onClose,
  onCancelGiftCard,
  cancellingGiftCard,
  allowIssueOpmOnCancel,
  notes,
  setNotes,
  issueOriginalPaymentMethod,
  setIssueOriginalPaymentMethod,
  giftCard,
  fetchingGiftCard,
  giftCardBlockingMessage,
  canVoidGiftCard,
}) => {
  const { t } = useTranslation()

  return (
    <Drawer show={show} onClose={onClose} options={{ showHeaderActions: false }}>
      <CardTitle Icon={GiftCardIcon}>{t('Anular tarjeta regalo')}</CardTitle>
      <Styles.MainContainer>
        <Text type="bodyMRegular">
          {t(
            'Esta operación anulará la tarjeta regalo anteriormente emitida. El cliente ya no podrá utilizarla para realizar una nueva compra.'
          )}
        </Text>
        <GiftCardBalance giftCard={giftCard} loading={fetchingGiftCard} />
        <InputWithLabel
          fullWidth
          label={t('Notas')}
          value={notes}
          onChange={e => setNotes(e.target.value)}
          Icon={ChatDotsIcon}
          maxLength="500"
          showCounter
        />
        {allowIssueOpmOnCancel && (
          <Switch
            checked={issueOriginalPaymentMethod}
            onChange={e => setIssueOriginalPaymentMethod(e.target.checked)}
            label={t('Reembolsar saldo restante al método de pago original')}
          />
        )}
        {giftCardBlockingMessage ? (
          <Alert type="error">{giftCardBlockingMessage}</Alert>
        ) : (
          <Alert type="warning">{t('Esta acción no se podrá deshacer más adelante. ¿Quieres continuar?')}</Alert>
        )}
        <Styles.ButtonsContainer>
          <Button fullWidth variant="outlined" onClick={onClose}>
            {t('Cancelar')}
          </Button>
          <ButtonWithSpinner
            fullWidth
            defaultLabel={t('Anular tarjeta regalo')}
            loadingLabel={t('Anulando tarjeta regalo')}
            onClick={onCancelGiftCard}
            loading={cancellingGiftCard}
            disabled={cancellingGiftCard || !notes || !canVoidGiftCard}
          />
        </Styles.ButtonsContainer>
      </Styles.MainContainer>
    </Drawer>
  )
}

export default CancelGiftCardDrawer
